import type { Base } from '../model/base';
import type { Login } from '../model/login';
import { api } from '../http';
import type { LoginSchema } from '../schema/login';
import type { Employer, Favorite } from '../model/employer';
import type { Session } from '../model/session';
import type { UpdateEmployer } from '../schema/employer';
import type { Bonus, BonusTask } from '../model/bonus';
import type { Review } from '../model/specialist';
import type { Template } from '../model/template';

export default class EmployerService {
  static async login(data: LoginSchema): Promise<Base<Login>> {
    return await api.post<Base<Login>>('/employer/login', data);
  }

  static async getSessions(): Promise<Base<Session[]>> {
    return await api.get<Base<Session[]>>('/employer/sessions');
  }

  static async deleteSession(sessionId: number) {
    return await api.delete(`/employer/sessions/${sessionId}`);
  }

  static async deleteAllSessions() {
    return await api.delete('/employer/sessions');
  }

  static async getFavorites(page: number = 1): Promise<Base<Favorite[]>> {
    return await api.get<Base<Favorite[]>>('/employer/specialist/get-favorites', { params: { page } });
  }

  static async getMe(): Promise<Base<Employer>> {
    return await api.get<Base<Employer>>('/employer');
  }

  static async getTemplateMessages(): Promise<Base<Template[]>> {
    return await api.get<Base<Template[]>>('/employer/vacancy/template-messages');
  }

  static async updateTemplateMessage(data: Template[]) {
    return await api.post('/employer/vacancy-template-messages/update', { templates: data });
  }

  static async getBonuses(): Promise<Base<Bonus[]>> {
    return await api.post<Base<Bonus[]>>('/employer/bonus-exchange/history', { user_type: 'employer' });
  }

  static async getAvailableBonusTasks(): Promise<Base<BonusTask[]>> {
    return await api.post<Base<BonusTask[]>>('/employer/bonuses');
  }

  static async getReviews(userId: number, page: number = 1): Promise<Base<Review[]>> {
    return await api.get<Base<Review[]>>(`/employers/${userId}/reviews`, { params: { page } });
  }

  static async updateProfile(data: UpdateEmployer): Promise<Base<Employer>> {
    return await api.post<Base<Employer>>('/employer/update-info', data);
  }
}
